// NENSONS CALCULATOR - Core Logic
(function() {
  'use strict';

  // ── Default rates (module-scoped so getSellerEarnings can read them) ──
  var commissionPercent = 3.5;
  var fixedCost         = 5.0;
  var yourRatePercent   = 2.5;

  /**
   * Formatea un número con separadores de miles y decimales
   * @param {number} value - El número a formatear
   * @param {boolean} isCurrency - Si es formato moneda (con $ y MXN)
   * @returns {string} Número formateado
   */
  function formatNumber(value, isCurrency = false) {
    if (value === null || value === undefined || isNaN(value)) return '';
    
    const formatted = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    if (isCurrency) {
      return '$ ' + formatted + ' MXN';
    }
    return formatted;
  }
  
  /**
   * Parsea un string formateado (con comas, $, MXN) a número
   * @param {string} formattedValue - El string a parsear
   * @returns {number} Número parseado
   */
  function parseFormattedNumber(formattedValue) {
    if (!formattedValue || typeof formattedValue !== 'string') return 0;
    
    let cleaned = formattedValue.replace(/[^0-9.,-]/g, '');
    cleaned = cleaned.replace(/,/g, '');
    cleaned = cleaned.replace(',', '.');
    
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
  
  /**
   * Inicializa la calculadora de ganancias
   * Lee las comisiones desde los atributos data-* del contenedor
   */
  function initCalculator() {
    var inp = document.getElementById('salePrice-full');
    var out = document.getElementById('sellerShare-full');
    var rst = document.getElementById('calcResetBtn');
    
    if (!inp || !out) {
      console.warn('Nensons Calculator: Required elements not found');
      return;
    }
    
    // Leer configuraciones del contenedor
    var container = document.getElementById('nensons-calculator-full');

    if (container) {
      if (container.dataset.shopifyCommission) {
        var parsedComm = parseFloat(container.dataset.shopifyCommission);
        if (!isNaN(parsedComm)) commissionPercent = parsedComm;
      }
      if (container.dataset.fixedCost) {
        var parsedFixed = parseFloat(container.dataset.fixedCost);
        if (!isNaN(parsedFixed)) fixedCost = parsedFixed;
      }
      if (container.dataset.yourRate) {
        var parsedRate = parseFloat(container.dataset.yourRate);
        if (!isNaN(parsedRate)) yourRatePercent = parsedRate;
      }
    }
    
    var commissionDecimal = commissionPercent / 100;
    var yourRateDecimal   = yourRatePercent   / 100;
    var updating = false;
    
    function calculateShare() {
      if (updating) return;
      updating = true;
      
      var salePrice = parseFormattedNumber(inp.value);
      var isValid   = !isNaN(salePrice) && isFinite(salePrice) && salePrice > 0;
      
      if (!isValid) {
        out.value = '';
        if (rst) rst.classList.remove('has-value');
        updating = false;
        return;
      }
      
      var commissionAmount = salePrice * commissionDecimal;
      var yourRateAmount   = salePrice * yourRateDecimal;
      var totalDeductions  = commissionAmount + fixedCost + yourRateAmount;
      var sellerShare      = salePrice - totalDeductions;
      if (sellerShare < 0) sellerShare = 0;
      
      out.value = formatNumber(sellerShare, true);
      if (rst) rst.classList.add('has-value');
      
      updating = false;
    }
    
    function resetCalculator(e) {
      if (e) e.preventDefault();
      updating = true;
      inp.value = '';
      out.value = '';
      if (rst) rst.classList.remove('has-value');
      inp.focus();
      updating = false;
      var resetEvent = new CustomEvent('calculator:reset', { detail: { source: 'resetButton' } });
      if (container) container.dispatchEvent(resetEvent);
    }
    
    inp.addEventListener('input', function() { calculateShare(); });
    inp.addEventListener('blur',  function() { calculateShare(); });
    
    if (rst) rst.addEventListener('click', resetCalculator);
    
    inp.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); calculateShare(); }
    });
    
    inp.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === 'Tab'       || e.key === 'Backspace' ||
          e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'Home'   || e.key === 'End') return;
      if (!/^[\d.]$/.test(e.key)) { e.preventDefault(); }
      var decimalCount = (inp.value.match(/\./g) || []).length;
      if (e.key === '.' && decimalCount >= 1) e.preventDefault();
    });
    
    calculateShare();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }
  
  // Exponer API pública
  window.NensonsCalculator = {
    init:                 initCalculator,
    formatNumber:         formatNumber,
    parseFormattedNumber: parseFormattedNumber,
    version:              '1.5.0',
    // ── Used by sold page to compute seller earnings without exposing rates ──
    getSellerEarnings: function(salePrice) {
      var n = Number(salePrice);
      if (!Number.isFinite(n) || n <= 0) return 0;
      var earnings = n - (n * commissionPercent / 100) - fixedCost - (n * yourRatePercent / 100);
      return earnings > 0 ? earnings : 0;
    }
  };

})();